import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App.tsx";
import { AppProvider } from "./context/AppContext.tsx";
import { AppProviderV2 } from "./context_v2/AppContext_v2.tsx";
import { unregister as unregisterSW } from "./serviceWorkerRegistration";
import "./index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <BrowserRouter>
    <AppProvider>
      <AppProviderV2>
        <App />
      </AppProviderV2>
    </AppProvider>
  </BrowserRouter>
);

// Отключаем Service Worker, чтобы не залипали старые ассеты после деплоя.
unregisterSW();
